import { HttpContextToken } from '@angular/common/http';

/**
 * Opt a single request out of the global error dialog raised by HttpErrorInterceptor.
 *
 * Use it only where the caller renders the failure itself - e.g. a form that maps `errors[]` onto
 * its own controls. Everything else should let the interceptor report, so the wording and the
 * support reference id stay consistent across the portal.
 *
 * Usage:
 *   this.http.post(url, body, {
 *     context: new HttpContext().set(SKIP_GLOBAL_ERROR_ALERT, true)
 *   });
 */
export const SKIP_GLOBAL_ERROR_ALERT = new HttpContextToken<boolean>(() => false);
